import { Component, Input } from '@angular/core';
import { TraitementDataComponent } from "../traitement-data/traitement-data.component";
import { Patient } from '../../../models/patient';
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';

@Component({
  selector: 'app-traitement-data-epap-95',
  standalone: true,
  imports: [TraitementDataComponent, ALaDateDuPipe],
  templateUrl: './traitement-data-epap-95.component.html',
  styleUrl: './traitement-data-epap-95.component.scss'
})
export class TraitementDataEpap95Component {
  @Input() patient: Patient | undefined;
}
